// assets/infinite-scroll-collection.js
(function() {
  if (!document.querySelector('#product-grid, .collection')) return;

  // Styles einmal einfügen
  if (!document.querySelector('#infinite-scroll-styles')) {
    const style = document.createElement('style');
    style.id = 'infinite-scroll-styles';
    style.textContent = `
      .pagination-wrapper {
        opacity: 0 !important;
        pointer-events: none !important;
        height: 1px !important;
        margin: 0 !important;
        padding: 0 !important;
        overflow: hidden !important;
      }
      #infinite-scroll-loader {
        display: none;
        text-align: center;
        padding: 2.5rem 1rem;
        width: 100%;
        font-family: var(--font-body-family);
        color: rgba(var(--color-foreground), 0.75);
        font-size: 1.6rem;
      }
      .infinite-scroll-spinner {
        display: inline-block;
        width: 28px;
        height: 28px;
        border: 3px solid rgba(var(--color-foreground), 0.1);
        border-radius: 50%;
        border-top-color: rgb(var(--color-foreground));
        animation: spin 0.8s linear infinite;
        margin-right: 12px;
        vertical-align: middle;
      }
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `;
    document.head.appendChild(style);
  }

  let activeObserver = null;
  let loaderElement = null;

  function initInfiniteScroll() {
    const productGrid = document.querySelector('#product-grid');
    const paginationWrapper = document.querySelector('.pagination-wrapper');

    if (!productGrid || !paginationWrapper) return;

    if (activeObserver) {
      activeObserver.disconnect();
      activeObserver = null;
    }

    if (!loaderElement) {
      loaderElement = document.createElement('div');
      loaderElement.id = 'infinite-scroll-loader';
      loaderElement.innerHTML = `
        <span class="infinite-scroll-spinner"></span>
        <span>Weitere Produkte laden …</span>
      `;
      productGrid.parentNode.insertBefore(loaderElement, productGrid.nextSibling);
    }

    let isLoading = false;
    let hasNextPage = true;

    function getNextPageUrl() {
      const nextLink = paginationWrapper.querySelector('.pagination__item-arrow[aria-label="Nächste Seite"]');
      return nextLink ? nextLink.href : null;
    }

    async function loadNextPage() {
      if (isLoading || !hasNextPage) return;

      const url = getNextPageUrl();
      if (!url) {
        hasNextPage = false;
        if (loaderElement) loaderElement.style.display = 'none';
        return;
      }

      isLoading = true;
      if (loaderElement) loaderElement.style.display = 'block';

      try {
        const response = await fetch(url);
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');

        const newProducts = doc.querySelectorAll('#product-grid > li, #product-grid > .grid__item');
        if (newProducts.length > 0) {
          productGrid.append(...newProducts);
        }

        const newPagination = doc.querySelector('.pagination-wrapper');
        if (newPagination) {
          paginationWrapper.innerHTML = newPagination.innerHTML;
        }

        hasNextPage = !!paginationWrapper.querySelector('.pagination__item-arrow[aria-label="Nächste Seite"]');

        if (!hasNextPage && loaderElement) {
          loaderElement.style.display = 'none';
        }

      } catch (error) {
        console.error('Infinite Scroll Fehler:', error);
        hasNextPage = false;
        if (loaderElement) loaderElement.style.display = 'none';
      } finally {
        isLoading = false;
        if (loaderElement) loaderElement.style.display = 'none';
      }
    }

    activeObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !isLoading && hasNextPage) {
          loadNextPage();
        }
      });
    }, {
      rootMargin: '400px',
      threshold: 0.1
    });

    activeObserver.observe(paginationWrapper);
  }

  function watchContainer() {
    const container = document.querySelector('#ProductGridContainer, .collection');
    if (!container) return;

    const containerObserver = new MutationObserver(() => {
      setTimeout(initInfiniteScroll, 100);
    });

    containerObserver.observe(container, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initInfiniteScroll();
    watchContainer();
  });
})();